import type { FC } from "react";
import { TextInput } from "flowbite-react";
import { InputValidationResult } from "../../types";
import { useTranslation } from "react-i18next";
import { getValidationMessage } from "../../helpers/validationHelper";
import { cn, inputSurface } from "@design-system";

interface TextInputProps {
  id: string;
  placeholder?: string;
  defaultValue?: string | number;
  value?: string | number;
  required?: boolean;
  type?: string;
  step?: number | string;
  min?: number | string;
  max?: number | string;
  validation?: InputValidationResult;
  disabled?: boolean;
  onInputChanged?: (input: string) => void;
  className?: string;
}

export const StyledTextInput: FC<TextInputProps> = function (
  props: TextInputProps,
) {
  const { t } = useTranslation(["common"]);

  const inputClassName =
    props.type === "number"
      ? "appearance-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      : "";

  const customTheme = {
    field: {
      input: {
        base: cn("w-full", inputSurface, inputClassName, props.className),
      },
    },
  };

  return (
    <TextInput
      id={props.id}
      name={props.id}
      theme={customTheme}
      placeholder={props.placeholder ?? ""}
      {...(props.value !== undefined
        ? { value: props.value }
        : { defaultValue: props.defaultValue ?? "" })}
      type={props.type ?? "text"}
      step={props.step}
      min={props.min}
      max={props.max}
      required={props.required ?? false}
      disabled={props.disabled ?? false}
      color={
        props.validation?.show &&
        (props.validation?.isMissing || props.validation?.isInvalid)
          ? "failure"
          : ""
      }
      helperText={
        props.validation?.show ? getValidationMessage(props.validation, t) : ""
      }
      onChange={(e) =>
        props.onInputChanged ? props.onInputChanged(e.target.value) : null
      }
    />
  );
};
